// Placeholder origin used only to resolve the redirect value; it is never requested (see also RFC 2606).
const BASE_ORIGIN = 'https://redirect.invalid'

/**
 * Returns the redirect target if it is a relative path on our own site, otherwise undefined.
 * Prevents open redirects like `?redirect=https://evil.example` or `?redirect=//evil.example`.
 * @param redirect Value of the `redirect` query parameter
 */
export const getSafeRedirect = (redirect: string | string[] | undefined): string | undefined => {
  if (typeof redirect !== 'string' || !redirect.startsWith('/')) {
    return undefined
  }

  try {
    // Resolve like the browser does (handles `//host`, `/\host`, tabs/newlines, ...)
    const url = new URL(redirect, BASE_ORIGIN)
    if (url.origin !== BASE_ORIGIN) {
      return undefined
    }
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return undefined
  }
}
